(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  class StNavMenus extends HTMLElement {
    connectedCallback() {
      const root = document.getElementById(this.dataset.header) || document;
      this.headerWrapper = root.querySelector('.header-wrapper');
      this.resPanel = this.querySelector('.st-resources');
      this.resToggle = root.querySelector('.st-resources__toggle');
      this.menuPanel = this.querySelector('.st-mmenu');
      this.menuToggle = root.querySelector('.st-mmenu__toggle');
      // Every fold in the panel — Resources, and Location beneath it — each
      // paired with its own panel by aria-controls. querySelector took only
      // the first, and a second fold added below it opened nothing.
      this.accs = Array.from(this.querySelectorAll('.st-mmenu__acc'));
      this.searchRow = this.querySelector('.st-mmenu__searchrow');
      this.searchSummary = root.querySelector('.st-header__search summary');
      this.desktop = window.matchMedia('(min-width: 750px)');

      if (this.resToggle && this.resPanel) {
        // As a link the click navigates to the journal, so only the button
        // variant toggles on click. Focus opens it either way, so keyboard
        // users can tab straight from Resources into the dropdown's links.
        if (this.resToggle.tagName !== 'A') {
          this.resToggle.addEventListener('click', () => this.setResources(!this.resPanel.classList.contains('is-open')));
        }
        this.resToggle.addEventListener('focus', () => this.setResources(true));
        // Hover-open is desktop behaviour
        this.resToggle.addEventListener('mouseenter', () => { if (this.desktop.matches) this.setResources(true); });
        this.onWrapperLeave = () => this.setResources(false);
        if (this.headerWrapper) this.headerWrapper.addEventListener('mouseleave', this.onWrapperLeave);
      }
      if (this.menuToggle && this.menuPanel) {
        this.menuToggle.addEventListener('click', () => this.setMenu(!this.menuPanel.classList.contains('is-open')));
      }
      this.accs.forEach((acc) => {
        const sub = document.getElementById(acc.getAttribute('aria-controls'));
        if (!sub) return;
        // Instant expand/collapse — no animation, like the rest of the theme
        acc.addEventListener('click', () => {
          const open = !sub.classList.contains('is-open');
          sub.classList.toggle('is-open', open);
          acc.setAttribute('aria-expanded', open ? 'true' : 'false');
          const glyph = acc.querySelector('[data-glyph]');
          if (glyph) glyph.textContent = open ? '−' : '+';
        });
      });
      if (this.searchRow) {
        this.searchRow.addEventListener('click', () => {
          this.setMenu(false);
          // The hidden summary still drives Dawn's details-modal
          if (this.searchSummary) this.searchSummary.click();
        });
      }

      this.onDocClick = (e) => {
        if (
          this.resPanel && this.resPanel.classList.contains('is-open') &&
          !this.resPanel.contains(e.target) &&
          !(this.resToggle && this.resToggle.contains(e.target))
        ) this.setResources(false);
      };
      this.onKeydown = (e) => {
        if (e.key === 'Escape') { this.setResources(false); this.setMenu(false); }
      };
      // Focus opens the dropdown, so tabbing past it has to close it again
      this.onFocusIn = (e) => {
        if (
          this.resPanel && this.resPanel.classList.contains('is-open') &&
          !this.resPanel.contains(e.target) &&
          !(this.resToggle && this.resToggle.contains(e.target))
        ) this.setResources(false);
      };
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('focusin', this.onFocusIn);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('focusin', this.onFocusIn);
      if (this.headerWrapper && this.onWrapperLeave) this.headerWrapper.removeEventListener('mouseleave', this.onWrapperLeave);
      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', this.onResize);
          window.visualViewport.removeEventListener('scroll', this.onResize);
        }
      }
      if (this.section && this.onSlid) this.section.removeEventListener('transitionend', this.onSlid);
      document.body.classList.remove('overflow-hidden', 'st-menu-open');
    }

    setResources(open) {
      if (!this.resPanel) return;
      this.resPanel.classList.toggle('is-open', open);
      if (this.resToggle) this.resToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // The panel hangs from the header's foot. `top: 100%` says that only while
    // the header is in the wrapper's flow: on the home page, below 990px,
    // mw.style.css takes the header out of it (position: absolute, so it can
    // sit over the hero), the wrapper collapses to nothing, and the panel
    // opened at the top of the window — over the logo and the ✕ that closes
    // it. So the foot is MEASURED: the header's own bottom within the wrapper,
    // which on every other page is exactly what 100% already was.
    placeMenu() {
      const bar = this.headerWrapper && this.headerWrapper.querySelector('header');
      if (!bar || !this.menuPanel) return;
      this.menuPanel.style.top = (bar.offsetTop + bar.offsetHeight) + 'px';
      // …and it ends at the foot of what can be SEEN. The body is locked while
      // the menu is open, so a fold taller than what is left beneath the bar
      // (the Location list) could not be reached at all; held to that room
      // the panel scrolls inside itself (its rule says so).
      //
      // The foot is the VISUAL viewport's where there is one. Tapping Rest of
      // world focuses the country search and raises the keyboard, and on a
      // phone the keyboard shrinks the visual viewport alone — innerHeight
      // does not move and the window fires no resize — so read off the window
      // the panel kept a height the keyboard covered, and the tail of the
      // list could not be scrolled up from under it. Neither is 100vh, which
      // on a phone is the window without the browser's bars. setMenu()
      // listens to both viewports, so the bars folding away, a turn of the
      // phone and the keyboard each measure it again.
      const vv = window.visualViewport;
      const foot = vv ? vv.offsetTop + vv.height : window.innerHeight;
      const room = foot - bar.getBoundingClientRect().bottom;
      this.menuPanel.style.maxHeight = Math.max(0, Math.round(room)) + 'px';
    }

    setMenu(open) {
      if (!this.menuPanel) return;
      if (open) {
        this.placeMenu();
        if (!this.onResize) {
          this.onResize = () => { if (this.menuPanel.classList.contains('is-open')) this.placeMenu(); };
          window.addEventListener('resize', this.onResize);
          // the keyboard, and a pan while it is up (see placeMenu)
          if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.onResize);
            window.visualViewport.addEventListener('scroll', this.onResize);
          }
          // A Menu press that lands while the sticky header is still sliding
          // back into view (base.css: .animate, 0.15s) measures a bar that is
          // part-way down, and the panel runs past the window by the rest of
          // the slide. Measured again once the slide has finished.
          this.section = document.getElementById(this.dataset.header);
          if (this.section) {
            this.onSlid = (e) => { if (e.target === this.section && e.propertyName === 'transform') this.onResize(); };
            this.section.addEventListener('transitionend', this.onSlid);
          }
        }
      } else {
        // Shut, it forgets where it was scrolled to: opened again it starts
        // at Browse the collection rather than somewhere down the countries
        // with every row of the menu itself out of sight.
        this.menuPanel.scrollTop = 0;
      }
      this.menuPanel.classList.toggle('is-open', open);
      if (this.menuToggle) {
        this.menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.menuToggle.setAttribute('aria-label', open ? 'Close menu' : this.menuToggle.dataset.label || 'Menu');
      }
      document.body.classList.toggle('st-menu-open', open);
      document.body.classList.toggle('overflow-hidden', open);
    }
  }

  if (!customElements.get('st-nav-menus')) customElements.define('st-nav-menus', StNavMenus);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-instagram-strip"] && !Shopify.designMode) return;
  try {
    
  class HomeIgStrip extends HTMLElement {
    connectedCallback() {
      this.strip = this.querySelector('[data-igs-strip]');
      this.prev = this.querySelector('[data-igs-prev]');
      this.next = this.querySelector('[data-igs-next]');
      if (!this.strip || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollByCard(-1));
      this.next.addEventListener('click', () => this.scrollByCard(1));
      this.strip.addEventListener('scroll', () => this.updateEnds(), { passive: true });
      window.addEventListener('resize', () => this.updateEnds());
      this.updateEnds();
    }

    cardStep() {
      const card = this.strip.querySelector('.igs__card');
      const gap = parseFloat(getComputedStyle(this.strip).columnGap || getComputedStyle(this.strip).gap) || 10;
      return card ? card.offsetWidth + gap : 240;
    }

    scrollByCard(dir) {
      this.strip.scrollBy({ left: dir * this.cardStep(), behavior: 'smooth' });
    }

    updateEnds() {
      const atStart = this.strip.scrollLeft <= 4;
      const atEnd = this.strip.scrollLeft >= this.strip.scrollWidth - this.strip.clientWidth - 4;
      this.prev.toggleAttribute('disabled', atStart);
      this.next.toggleAttribute('disabled', atEnd);
    }
  }

  if (!customElements.get('home-ig-strip')) customElements.define('home-ig-strip', HomeIgStrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-press-no-image"] && !Shopify.designMode) return;
  try {
    
  class PressSwitcher extends HTMLElement {
    connectedCallback() {
      this.pubs = this.querySelectorAll('[data-press-pub]');
      this.quotes = this.querySelectorAll('[data-press-quote]');
      this.pubs.forEach((btn) => btn.addEventListener('click', () => this.activate(btn.dataset.index)));
    }

    activate(index) {
      this.pubs.forEach((btn) => {
        const active = btn.dataset.index === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.quotes.forEach((q) => q.classList.toggle('is-active', q.dataset.index === index));
    }
  }

  if (!customElements.get('press-switcher')) customElements.define('press-switcher', PressSwitcher);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-press"] && !Shopify.designMode) return;
  try {
    
  class PressSwitcher extends HTMLElement {
    connectedCallback() {
      this.pubs = this.querySelectorAll('[data-press-pub]');
      this.quotes = this.querySelectorAll('[data-press-quote]');
      this.pubs.forEach((btn) => btn.addEventListener('click', () => this.activate(btn.dataset.index)));
    }

    activate(index) {
      this.pubs.forEach((btn) => {
        const active = btn.dataset.index === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.quotes.forEach((q) => q.classList.toggle('is-active', q.dataset.index === index));
    }
  }

  if (!customElements.get('press-switcher')) customElements.define('press-switcher', PressSwitcher);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
